/** Decode JWT payload without verifying signature (client-side role checks only). */
export function decodeJwtPayload(
  accessToken: string | null | undefined,
): Record<string, unknown> | null {
  if (!accessToken) {
    return null;
  }
  try {
    const segment = accessToken.split('.')[1];
    if (!segment) {
      return null;
    }
    const normalized = segment.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(
      normalized.length + ((4 - (normalized.length % 4)) % 4),
      '=',
    );
    return JSON.parse(atob(padded)) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function rolesFromAccessToken(
  accessToken: string | null | undefined,
): string[] {
  const payload = decodeJwtPayload(accessToken);
  const roles = payload?.['roles'];
  return Array.isArray(roles)
    ? roles.filter((role): role is string => typeof role === 'string')
    : [];
}

export function hasAnyRole(
  userRoles: string[],
  requiredRoles: string[] | undefined,
): boolean {
  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }
  return requiredRoles.some((role) => userRoles.includes(role));
}
